import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { usePriceContext } from "@/components/Price/price/context/price.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { formatPrice } from "@/utils/price.utils";

type Props = {
    className?: string;
};

export const Conversion = ({ className }: Props) => {
    const { t } = useGranite();

    const { conversionPrice, conversionUnit, size } = usePriceContext();

    const formattedPrice =
        isDefined(conversionPrice) && conversionUnit
            ? formatPrice(conversionPrice)
            : "";

    return (
        <span
            className={cn(
                "tw:block tw:w-fit",
                {
                    "tw:text-xs tw:min-h-3.5 tw:leading-3.5":
                        size === "sm" || size === "xs",
                    "tw:text-sm tw:min-h-4.5 tw:leading-4.5": size === "md",
                    "tw:min-h-5 tw:leading-5": size === "lg",
                    "tw:min-h-6 tw:leading-6": size === "xl"
                },
                "tw:text-nowrap",
                className
            )}
        >
            {formattedPrice && (
                <>
                    <span className={cn("tw:font-bold")}>{formattedPrice}</span>{" "}
                    {t("general.per")} {conversionUnit}
                </>
            )}
        </span>
    );
};
